import { CylinderGeometry } from 'three'

export default (radius: number, height: number) => {
  return new CylinderGeometry(radius, radius, height, 50, 1, true);
}
